import appConstant from "../constants/appConstant";
import { v4 as uuidv4 } from "uuid";

export const getNestedValue = (path, obj, defaultVal = null) =>
    path.split(".").reduce((acc, x) => (acc && acc[x] !== undefined && acc[x] !== null ? acc[x] : defaultVal), obj);

export const getNestedArrayLength = (path, obj) => (getNestedValue(path, obj) || []).length || 0;

export const isArray = (obj) => {
    return obj && obj.constructor === [].constructor;
};

export const isJson = (obj) => {
    return obj && obj.constructor === {}.constructor;
};

export const isJsonEmpty = (json) => {
    return json && json.constructor === Object && Object.keys(json).length === 0;
};

export const getPath = () => {
    if (window) {
        const location = getNestedValue("location.href", window);
        return location && (location.split(/\?/)[0] || "");
    } else {
        return "";
    }
};

export const getQueryString = () => {
    if (window) {
        const location = getNestedValue("location.href", window);
        return (location && location.split(/\?/)[1]) || "";
    } else {
        return "";
    }
};

export const getParamFromURL = (paramName, url) => {
    const regex = new RegExp(`[\\?&]${paramName.replace(/([[\]])/g, "\\$1")}=([^&#]*)`);
    const results = regex.exec(url);

    return (results && results[1]) || null;
};

export const scrubEmail = (text) => {
    const scrubText = "****.***";
    const regex = /(%40|@)+((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g;

    return text ? text.replace(regex, scrubText) : text;
};

export const getEnvVar = (val) => {
    return window?._env_?.[val];
};

export const normalizeZipCode = (zipCode) => {
    const regex = new RegExp(appConstant.WHITE_SPACE_EXPRESSION);
    return zipCode.replace(regex, "").trim();
};

export const generateTransactionId = () => {
    return `${appConstant.SOURCE_TYPE}_${uuidv4()}`;
};

export const isMobile = () => {
    const userAgent = typeof navigator === "undefined" ? "SSR" : navigator.userAgent;
    const isMobile = Boolean(userAgent.match(/iPhone|Android|iPod|Opera Mini|IEMobile/i));
    return isMobile;
};

export const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (isMobile) {
        document.body.scrollTo({ top: 0, behavior: "smooth" });
    }
};

export const getCurrencyPrefix = (countryCode) => {
    const currencyCode =
        countryCode === appConstant.COUNTRY_CODE_US ? appConstant.US_DOLLAR : appConstant.CANADIAN_DOLLAR;

    return currencyCode;
};

export const formatDigits = (price) => {
    const formattedWholeDigits = price.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return `${formattedWholeDigits}`;
};

export const getParentsQueryString = (params) => {
    const urlParams = new URLSearchParams(window.parent.location.search);

    return urlParams.get(params) || "";
};

export const getEncodedValue = (email) => {
    return encodeURIComponent(email);
};

export const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    }
    if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
    ) {
        return "mobile";
    }
    return "desktop";
};

export const updateQueryStringParameter = (uri, key, value) => {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
        return uri + separator + key + "=" + value;
    }
};
